export enum ValidationError {
  PATTERN = 'pattern',
  REQUIRED = 'required',
  AUTHORIZED_CHARACTERS = 'authorizedcaracteres',
  MAX_LENGTH = 'maxlength',
  SEPERATION = 'separation',
}
